import { fetchWithToken } from '@/services'

export const GET_RECENT_VIEWED_PRODUCTS = `
  query getRecentViewedProducts($currentPage: Int, $pageSize: Int) {
    recentViewedProducts(currentPage: $currentPage, pageSize: $pageSize) {
      currentPage
      pageSize
      totalPages
      total_count
      items {
        ...ProductInterfaceField
        ...ConfigurableProductField
      }
    }
  }
  fragment ProductInterfaceField on ProductInterface {
    __typename
    sku
    uid
    name
    url_key
    url_suffix
    canonical_url
    stock_status
    categories {
      __typename
      name
      url_key
      url_path
      level
      uid
      icon_image
      image
      path
    }
    meta_description
    meta_keyword
    meta_title
    new_from_date
    new_to_date
    description {
      ...ComplexTextValueFields
    }
    rating_summary
    review_count
    short_description {
      ...ComplexTextValueFields
    }
    thumbnail {
      position
      ...ProductImageFields
    }
    image {
      ...ProductImageFields
    }
    media_gallery {
      __typename
      disabled
      label
      url
      position
    }
    price_range {
      ...PriceRangeField
    }
    ...CustomField
  }
    fragment ConfigurableProductField on ConfigurableProduct {
  configurable_options {
    attribute_code
    position
    label
    attribute_code
    uid
    attribute_uid
    values {
      default_label
      label
      uid
      swatch_data {
        __typename
        value
      }
    }
  }
  variants {
    attributes {
      code
      label
      uid
      value_index
    }
    product {
      __typename
      uid
      stock_status
      short_description{
        html
      }
      special_price
      ...CustomField
      price_range {
        ...PriceRangeField
      }
      sku
      name
      url_key
      stock_status
      image {
        url
        label
      }
      small_image {
        url
        label
      }
      thumbnail {
        url
        position
      }
    }
  }
}
  fragment CustomField on ProductInterface {
    color
      daily_sale {
    end_date
    entity_id
    sale_price
    sale_qty
    saleable_qty
    sold_qty
    title
    title_en
    start_date
    __typename
  }
    rating_summary_start {
      star_1
      star_2
      star_3
      star_4
      star_5
    }
    attributes {
      attribute_code
      label
      value
    }
  }
  fragment PriceRangeField on PriceRange {
    __typename
    maximum_price {
      ...ProductPriceField
    }
    minimum_price {
      ...ProductPriceField
    }
  }
  fragment ProductPriceField on ProductPrice {
    discount {
      amount_off
      percent_off
    }
    final_price {
      ...MoneyFields
    }
    regular_price {
      ...MoneyFields
    }
  }
  fragment ComplexTextValueFields on ComplexTextValue {
    html
  }
  fragment ProductImageFields on ProductImage {
    url
  }
  fragment MoneyFields on Money {
    currency
    value
  }
`

export const RECENT_VIEWED_PRODUCTS = `
mutation recentViewedProducts($product_ids: [Int]!) {
  recentViewedProducts(product_ids: $product_ids) {
    message
    total_count
  }
}
`
export const getRecentProducts = async () => {
  try {
    return await fetchWithToken({
      query: GET_RECENT_VIEWED_PRODUCTS,
      variables: {
        currentPage: 1,
        pageSize: 20,
      },
    }).then((data) => {
      return data?.payload?.data?.recentViewedProducts?.items || []
    })
  } catch (err) {
    console.log('getRecentProducts', err)
  }
}

export const setRecentProducts = async (data: number[]) => {
  try {
    return await fetchWithToken({
      query: RECENT_VIEWED_PRODUCTS,
      variables: {
        product_ids: data,
      },
    })
  } catch (err) {
    console.log('setRecentProducts', err)
  }
}
